import React, { useState } from 'react'
import SImage from '../Image';

function ConfirmModal({title,title2,message,pic,show,setShow,handleSave,selected }) {
    let pict = false;
    const [selectedUser, setSelectedUser] = useState(selected);

    const handleCloseModal = () => {
        // setShowModal(false);
        setShow(false);
        // if (onClose) {
        //     onClose(); // Panggil fungsi navigasi setelah modal ditutup
        // }
    };

    const handleSaveModal = () => {
        handleSave(selectedUser, selectedUser);
    }

    if(pic !== '' || pic !== null){
        pict = true;
    }

  return (
    <>
       {show && ( <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body">
                        <div  style={{ display: 'block'}}>
                            <div className='d-flex justify-content-center'>
                               { pict && (
                                    <SImage alt={'no image'} source={pic} />
                               )}
                            </div>
                            <div className="swal2-html-container d-block" id="swal2-html-container">
                                {message}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleCloseModal}
                        >
                            {title}
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveModal}
                        >
                            {title2}
                        </button>
                    </div>
                </div>
            </div>
        </div> )
        }
    </>
  );
}

export default ConfirmModal;